import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';
import Button from '../ui/Button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between">
        
        <Link to="/" className="flex flex-col items-center z-50">
          <span className="font-serif text-2xl tracking-wider text-veloura-text">VELOURA</span>
          <span className="text-[10px] tracking-[0.2em] uppercase text-veloura-accent mt-1">Lash Studio</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} className="text-sm font-medium text-veloura-text hover:text-veloura-accent transition-colors">
              {link.name}
            </Link>
          ))}
          <Button to="/book" variant="primary" className="ml-4 px-6 py-2">Book Now</Button>
        </nav>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-2xl text-veloura-text z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} />
        </button>

        {/* Mobile Menu */}
        <div className={`fixed inset-0 bg-veloura-bg z-40 flex flex-col items-center justify-center transition-transform duration-500 ease-in-out lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="flex flex-col items-center gap-6 text-lg">
            {navLinks.map((link) => (
              <Link key={link.name} to={link.path} className="font-serif text-2xl text-veloura-text hover:text-veloura-accent transition-colors">
                {link.name}
              </Link>
            ))}
            <Button to="/book" variant="primary" className="mt-8 w-64">Book Appointment</Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;